import {motion, AnimatePresence} from 'framer-motion';
import { useContext, useEffect } from "react";
import GeneralContext from "../context/GeneralContext";
import { useNavigate } from "react-router-dom";
import logoMini from '../components/assets/logoMini.png';
import NavIcon from '../components/shared/NavIcon';
import { FaFileUpload, FaUser  } from 'react-icons/fa';
import { GiTwoCoins } from "react-icons/gi";
import { FaBook } from "react-icons/fa6";
import { SlLogout } from "react-icons/sl";
import Welcome from '../components/userMenu/Welcome';
import PasswordReset from '../components/userMenu/PasswordReset';
import Request from '../components/userMenu/Request';
import Points from '../components/userMenu/Points';
import History from '../components/userMenu/History';
import ActiveRequests from '../components/userMenu/ActiveRequests';
import ProcessedRequests from '../components/userMenu/ProcessedRequests';
import { IoIosMenu } from "react-icons/io";

function NormalUser() {

  const { setUserType, redirect, logout, userPoints, changeUserPoints, userMenu, changeUserMenu, changeModalClass } = useContext(GeneralContext);

  const navigate = useNavigate();

  useEffect(() => {
    changeModalClass('button');
    const redirectFunction = async () => {
      const redirectResponse = await redirect('user');
      if (!redirectResponse.success) {
        navigate('/')

      } else {
        changeUserPoints(redirectResponse.points);
        setUserType('user');
      }
    }
    redirectFunction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logoutFunction = () => {
    logout();
    navigate('/');
  }

  const mobileModalFunction = () => {
    const mobileModal = document.getElementById("mobileModal");
    mobileModal.style.display = "block";
  }

  return (
    <div className='doubleColumnMain'>
      <motion.div
        key='leftColumnUser'
        className='menuDiv'
        initial={{x: -500}}
        animate={{x: 0}}
        exit={{x: -500}}
        transition={{duration: 1}}>
          <div style={{textAlign: 'center'}}>
            <div className='desktopMenu'>
              <img src={logoMini} alt='logo' className='logoMenu' />
              <br />
              <label style={{color: '#FFFFFF', fontSize: '20px', fontWeight: '600'}}>{userPoints}</label>
              <br />
              <br />
              <br />
              <NavIcon text='Usuario' buttonFunction={changeUserMenu} buttonArguments='user'>
                <FaUser size='40' color='#FFFFFF'/>
              </NavIcon>
              <br />
              <NavIcon text='Solicitar' buttonFunction={changeUserMenu} buttonArguments='request'>
                <FaFileUpload size='40' color='#FFFFFF'/>
              </NavIcon>
              <br />
              <NavIcon text='Puntos' buttonFunction={changeUserMenu} buttonArguments='points'>
                <GiTwoCoins size='40' color='#FFFFFF'/>
              </NavIcon>
              <br />
              <NavIcon text='Mis Solicitudes' buttonFunction={changeUserMenu} buttonArguments={'history'}>
                <FaBook size='40' color='#FFFFFF'/>
              </NavIcon>
              <br />
              <NavIcon text='Cerrar Sesión' buttonFunction={logoutFunction}>
                <SlLogout size='40' color='#FFFFFF'/>
              </NavIcon>
            </div>
          </div>
          <div className='mobileMenu'>
            <div className='mobileLeftColumn'>
              <img src={logoMini} alt='logo' className='logoMenu' />
            </div>
            <div className='mobileRightColumn'>
              <NavIcon text='' buttonFunction={mobileModalFunction}>
                <IoIosMenu size='40' color='#FFFFFF'/>
              </NavIcon>
            </div>
          </div>
      </motion.div>
      <motion.div
        key='rightColumnUser'
        className='mainContainer'
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        exit={{opacity: 0}}
        transition={{duration: 1, delay: 1}}>
          <AnimatePresence mode='wait'>
            {userMenu === 'user' ? <Welcome key='userMenu'/> : null}
              {userMenu === 'reset' ? <PasswordReset key='resetMenu'/> : null}
            {userMenu === 'request' ? <Request key='requestMenu'/> : null}
              {userMenu === 'active-requests' ? <ActiveRequests key='activeRequests'/> : null}
              {userMenu === 'processed-requests' ? <ProcessedRequests key='processedRequests'/> : null}
            {userMenu === 'points' ? <Points key='pointsMenu'/> : null}
            {userMenu === 'history' ? <History key='historyMenu'/> : null}
          </AnimatePresence>
      </motion.div>
    </div>
  )
}

export default NormalUser